module.exports = __webpack_public_path__ + "static/school_obj8@2x-434285b876ecda5ab117cd381b38b5e1.png";